import React, { useMemo, useState } from "react";
import { useGetAuditLogsQuery } from "../../../redux/services/admin/adminApi";

/**
 * Read-only list of security audit entries (super admin).
 */
const AuditLogsPage = () => {
  const [tenantId, setTenantId] = useState("");
  const queryArgs = useMemo(
    () => ({
      tenantId: tenantId.trim() || undefined,
      limit: 100,
      skip: 0,
    }),
    [tenantId]
  );
  const { data, isLoading, isError, error } = useGetAuditLogsQuery(queryArgs);

  const rows = data?.data || [];

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">Audit log</h1>
      <p className="text-sm text-gray-600 mb-6">
        Immutable records of sensitive actions. Filter by tenant (Customer)
        ObjectId.
      </p>
      <div className="mb-4 flex gap-2 items-center">
        <label className="text-sm text-gray-700" htmlFor="tenantFilter">
          Tenant ID
        </label>
        <input
          id="tenantFilter"
          className="border rounded px-2 py-1 text-sm w-64"
          placeholder="optional Mongo ObjectId"
          value={tenantId}
          onChange={(e) => setTenantId(e.target.value)}
        />
      </div>
      {isLoading && <p className="text-gray-500">Loading…</p>}
      {isError && (
        <p className="text-red-600">
          {error?.data?.message || "Failed to load audit log"}
        </p>
      )}
      {!isLoading && !isError && (
        <div className="overflow-x-auto border rounded">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left">Time</th>
                <th className="px-3 py-2 text-left">Action</th>
                <th className="px-3 py-2 text-left">Actor</th>
                <th className="px-3 py-2 text-left">Tenant</th>
                <th className="px-3 py-2 text-left">Target</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row._id} className="border-t">
                  <td className="px-3 py-2 whitespace-nowrap">
                    {row.createdAt
                      ? new Date(row.createdAt).toLocaleString()
                      : "—"}
                  </td>
                  <td className="px-3 py-2">{row.action}</td>
                  <td className="px-3 py-2">
                    {row.actorEmail || String(row.actorUserId || "")}
                  </td>
                  <td className="px-3 py-2">{String(row.tenantId || "")}</td>
                  <td className="px-3 py-2">
                    {row.targetType} {row.targetId ? `· ${row.targetId}` : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && (
            <p className="p-4 text-gray-500">No entries yet.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default AuditLogsPage;
